import { useEffect, useState } from "react";
import * as Accordion from "components/accordion/accordion";
import Markdown from "components/markdown/markdown";

function decodeHtml(html: string): string {
  const txt = document.createElement("textarea");
  txt.innerHTML = html;
  return txt.value;
}

const FaqItem = ({ id, question, answer }) => {
  const [text, setText] = useState(answer);
  useEffect(() => {
    if (document) {
      // This removes html entities (e.g. `&#39;`) from a string, while
      // retaining tags. Rather than using dangerouslySetInnerHtml, this
      // allows us to pass text into the markdown component
      setText(decodeHtml(answer));
    }
    return () => {};
  }, [answer]);

  return (
    <Accordion.Item key={id} value={id}>
      <Accordion.Trigger>{question}</Accordion.Trigger>
      <Accordion.Content>
        <div className="[&_a]:underline [&_li]:list-inside [&_li]:list-disc">
          <Markdown text={text} />
        </div>
      </Accordion.Content>
    </Accordion.Item>
  );
};

export const Faq = ({ title = null, faq }) => {
  return (
    <>
      {faq && faq.length > 0 && (
        <div className="w-full">
          <h3 className="mb-3 font-recklessBold text-[32px] leading-[130%]">
            {title}
          </h3>
          <Accordion.Root
            type={"single"}
            collapsible={true}
            className={"w-full"}
          >
            {faq.map(({ question, answer, id }) => {
              return (
                <FaqItem key={id} id={id} question={question} answer={answer} />
              );
            })}
          </Accordion.Root>
        </div>
      )}
    </>
  );
};
